import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { BehaviorSubject } from 'rxjs';
import { Tarea } from '../../../models/tareas.model';
import { BitacoraActividadesInterface } from '../../../models/bitacora.model';
import { environment } from 'environments/environments';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { DetalleSolicitudVADTO } from 'app/models/solicitud-va-dto';
import { ActualizarMetadataDTO } from 'app/models/actualizar-metadata.model';
import { DatosUsuarioAsignado, usuariosAsignadosInterface } from 'app/models/usuarios-asignados.model';
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';

@Injectable({providedIn: 'root'})


export class DetalleTareaService {

    _detalleTarea: BehaviorSubject<Tarea> = new BehaviorSubject(null);
    _actividadTarea: BehaviorSubject<BitacoraActividadesInterface[]> = new BehaviorSubject<BitacoraActividadesInterface[]>([])
    _usuariosAsignados: BehaviorSubject<DatosUsuarioAsignado[]> = new BehaviorSubject<DatosUsuarioAsignado[]>([])
    elementosVinculadosTasks: BehaviorSubject<ElementosVinculadosInterface[]> = new BehaviorSubject<ElementosVinculadosInterface[]>([])
    _estadoTarea: BehaviorSubject<Tipologia[]> = new BehaviorSubject<Tipologia[]>([])
    private drawerOpen$ = new BehaviorSubject<boolean>(false);

    constructor(private apiService: ApiService) {

     }

    // -----------------------------------------------------------------------------------------------------
    // @ Properties
    // -----------------------------------------------------------------------------------------------------


    get detalleTarea$() {
        return this._detalleTarea.asObservable();
    }

    get _actividaTarea$(){
        return this._actividadTarea.asObservable();
    }

    //drawer
    get isDrawerOpen$() {
        return this.drawerOpen$.asObservable();
      }
    
      openDrawer() {
        this.drawerOpen$.next(true);
      }
    
      closeDrawer() {
        this.drawerOpen$.next(false);
      }

    get _usuariosAsignados$() {
        return this._usuariosAsignados.asObservable();
    }

    get elementosVinculadosTasks$(){
        return this.elementosVinculadosTasks.asObservable()
    }

    get estadosTarea$(){
        return this._estadoTarea.asObservable()
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get task details:  Servicio que obtiene el detalle de una entidad tipo tarea.
     * @param task_uuid task_uuid
     * retorna una promesa con el detalle de una entidad tipo TAREA
     * y conecta la data con un observable
     */
    getTaskDetails(task_uuid: string): Promise<Tarea> {
        return new Promise((resolve, reject) => {
            const url = `/tareas/${task_uuid}`;
            this.apiService.GetMethod(url, {}, 'Error al Obtener el detalle de la tarea')
                .subscribe((response: Tarea) => {
                    this._detalleTarea.next(response);
                    resolve(response);
                }, (error) => {
                })
            
        });
    }

    getActividadesTarea(params: any){
        const url='/bitacoras'
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: any) => {
                    this._actividadTarea.next(response.data)
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }

    getActividadesByTask(entidadUuid: string) {
        return this.getActividadesTarea({entidadUuid})
    }
    
    getTipologias(tipologiaPadreId:number){
        const url=`/tipologias/${tipologiaPadreId}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los tipologias.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    getTipologiasEstadoTask(tipologiaPadreId:number){
        const url=`/tipologias/${tipologiaPadreId}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los Estados.')
                .subscribe((response: TipologiasInterface) => {
                    this._estadoTarea.next(response[0].tipologias)
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    putPriodidadTarea(tareaUuid:string, params: any){
        const url=`/tareas/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url,null, params, 'Error al actualizar prioridad.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    putEstadoTarea(tareaUuid:string, params: any){
        const url=`/tareas/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url,null, params, 'Error al actualizar prioridad.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    postAprobarSolicitud(tareaUuid:string){
        const url=`/tareas/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url,{}, {}, 'Error al actualizar Estado.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    putDescripcion(descripcion:any, tareaUuid:string){
        const params={descripcion: true}
        const body = {descripcion: descripcion}
        const url=`/tareas/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, params, 'Error al actualizar Descripción.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    putFechaLimite(tareaUuid: string, fechaLimite: string){
        const params = { fechaLimite: fechaLimite };
        const url = `/tareas/${tareaUuid}`;
        return new Promise((resolve, reject) => {
            this.apiService
                .PutMethod(url, null, params, 'Error al actualizar Fecha Límite.')
                .subscribe(
                    (response) => resolve(response),
                    (error) => reject(true)
                );
        });
    }

    putMetadata(solicitud:ActualizarMetadataDTO, tareaUuid:string){
        const url= `/tareas/actualizar_metadata/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, solicitud, {},'Error al actualizar los datos de la Solicitud')
                .subscribe(resoponse =>{
                    resolve(resoponse)
                },error =>{
                    reject(true)
                })
        })
    }

    postRevisionFormularioVa(tareaUuid:string){
        const url=`/v-agil/revision/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url,null, {}, 'Error al actualizar Estado.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    getUsuariosAsignados(task_uuid:string){
        const url=`/asignacion-usuario/${task_uuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener usuarios asignados.')
                .subscribe((response: usuariosAsignadosInterface) => {
                    this._usuariosAsignados.next(response.data)
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    deleteUsuarioAsignado(asignacionId:number){
        let params = {asignacionId}
        const url=`/asignacion-usuario/`
        return new Promise((resolve, reject)=>{
            this.apiService.DeleteMethod(url, params, 'Error al eliminar usuario asignado.')
                .subscribe((response: any) => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    getElementosVinculados(task_uuid: string){
        const url=`/vinculo/${task_uuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los elementos vínculados.')
                .subscribe((response: ElementosVinculadosInterface[]) => {
                    this.elementosVinculadosTasks.next(response)
                    resolve(response)                  
                }, error => {
                    reject(true)
                })
        })
    }

    postDocumentosGestion(body:any, tareaUuid:string, ){
        const url=`/tareas/subir_documentos/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al guardar documentos.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    duplicarGestion(tareaUuid:string){
        const url=`/tareas/duplicar/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, null, {}, 'Error al generar gestión.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }
}
